<template>
  <div>
    <form @submit.prevent="tryToLogIn">
      <input type="hidden" name="opcion" value="login" />
      <div class="form-group">
        <label class="label_input" for="username">Ingrese su usuario</label>
        <input
          type="text"
          class="form-control-login"
          id="username"
          name="username"
          v-model="$v.usuario.username.$model"
          @blur="$v.usuario.username.$touch()"
          :class="{ error: $v.usuario.username.$error }"
        />
        <span
          v-if="$v.usuario.username.$error"
          class="help-block text-left text-error-input"
        >
          {{ messageValidation($v.usuario.username) }}
        </span>
        <span class="help-block text-left text-error-input" v-else>
          &nbsp;
        </span>
      </div>
      <div class="form-group">
        <label class="label_input" for="password">Digite su contraseña</label>
        <div class="input-password">
          <input
            :type="typeInput"
            class="form-control-login"
            id="password"
            name="password"
            placeholder=""
            v-model="$v.usuario.password.$model"
            @blur="$v.usuario.password.$touch()"
            :class="{ error: $v.usuario.password.$error }"
          />
          <span class="icon_eye" :class="{ 'color-icon': isEye }" @click.prevent="seePassword">
            {{ typeInput == "password" ? "Ver" : "Ocultar" }}
          </span>
        </div>
        <span
          v-if="$v.usuario.password.$error"
          class="help-block text-left text-error-input"
        >
          {{ messageValidation($v.usuario.password) }}
        </span>
        <span class="help-block text-left text-error-input" v-else>
          &nbsp;
        </span>
      </div>
      <div class="content-link">
        <div class="checkbox-login">
          <input type="checkbox" id="check1" />
          <label for="check1" class="label-checkbox">
            Recordar datos de acceso
          </label>
        </div>
      </div>
      <div class="box" v-if="isError">
        <p>
          {{ message }}
        </p>
        <span @click.prevent="isError = false">
          x
        </span>
      </div>
      <div class="content-btn-login">
        <button
          type="button"
          class="btn-register"
          @click="openModal()"
        >
          Registrate
        </button>
        <button
          :disabled="$v.$invalid || isBusy"
          type="submit"
          class="btn-login-form"
        >
          INGRESAR
          <div class="loader" v-if="isBusy" />
        </button>
      </div>
    </form>
    <b-modal
      v-model="modal"
      :id="`address-modal${idmodal}`"
      size="md"
      title="Registro de usuario"
      cancel-title="Cancelar"
      :okDisabled="document ? false : true"
      ok-title="Continuar"
      @ok="handleRegister"
    >
      <div class="row">
        <div class="col">
          <b-form-group
            id="fullname-group"
            label="Documento de identidad"
            label-for="fullname"
          >
            <div class="document_identity">
              <v-select
                v-model="usuario.type_document"
                class="type_document"
                label="code"
                :options="allDocuments"
              >
              <template #option="option">
                <span>{{ option.code }}  - {{ option.description }}</span>
              </template>
            </v-select>
              <b-form-input
                id="document"
                v-model="document"
                type="number"
              ></b-form-input>
            </div>
          </b-form-group>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { authMethods, commonMethods } from '@state/helpers'
// Vuelidate
import { required } from "vuelidate/lib/validators";
// Mixin
import { validationMixin } from '../../mixins'

export default {
  name: 'LogoutModal',
  mixins: [validationMixin],
  props: {
    msg: String,
  },
  data() {
    return {
      document: '',
      modal: false,
      allDocuments: [],
      usuario: {
        username: '',
        password: '',
        type_document: ''
      },
      isBusy: false,
      isError: false,
      typeInput: 'password',
      message: '',
      contract: null,
      user: null,
      isEye: false,
    }
  },
  validations: {
    usuario: {
      username: {
        required,
      },
      password: {
        required,
      },
    },
  },
  mounted () {
    this.fetchAllMasters('1').then((response) => {
      this.allDocuments = response.master_details
      this.usuario.type_document = response.master_details.find((it) => (it.code.toLowerCase() === 'cc'))
    })
  },
  methods: {
    ...commonMethods,
    ...authMethods,
    openModal() {
      this.modal = true
    },
    handleRegister() {
      this.$router.push({ name: 'register', params: { document: this.document } });
    },
    tryToLogIn() {
      const me = this
      me.isBusy = true
      // // Reset the authError if it existed.
      me.message = null
      return me.logIn({
        username: me.usuario.username.toLowerCase(),
        password: me.usuario.password,
      })
        .then((token) => {
          me.isBusy = false
          me.isError = false
          // Redirect to the originally requested page, or to the home page
          let redirectPath = me.$route.query.redirectFrom
            ? me.$route.query.redirectFrom === '/logout'
              ? null
              : me.$route.query.redirectFrom
            : null
          me.$router.push(redirectPath || { name: 'home' })
        })
        .catch((error) => {
          me.isBusy = false;
          const message = error.response
            ? error.response.data.non_field_errors[0]
            : 'Lo sentimos. En este momento no es posible autenticarse, intente más tarde'
          me.loadMessage(message);
        })
    },
    loadMessage(message) {
      const me = this
      me.message = message
      me.isError = true
      setTimeout(function() {
        me.isError = false
        me.message = ''
      }, 5000)
    },
    seePassword() {
      const me = this
      if (me.typeInput == "password") {
        me.typeInput = "text";
        me.isEye = true;
      } else {
        me.typeInput = "password";
        me.isEye = false;
      }
    },
  },
}
</script>
